import React from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Link,
  Divider,
  IconButton,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import FacebookIcon from "@mui/icons-material/Facebook";
import EmailIcon from "@mui/icons-material/Email";

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        background: "linear-gradient(135deg, #1a237e 0%, #0d1b6e 100%)",
        color: "white",
        pt: 6,
        pb: 3,
        mt: "auto",
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Company Info */}
          <Grid item xs={12} md={4}>
            <Typography variant="h5" fontWeight={800} gutterBottom>
              VeraInsight
            </Typography>
            <Typography
              variant="caption"
              sx={{
                fontStyle: "italic",
                opacity: 0.9,
                display: "block",
                mb: 2,
              }}
            >
              Where Insight Meets Care
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.8, lineHeight: 1.8 }}>
              Building disease-specific digital health platforms that connect
              patients, providers, and researchers.
            </Typography>
            <Box sx={{ mt: 2, display: "flex", gap: 1 }}>
              <IconButton
                sx={{ color: "white", opacity: 0.8, "&:hover": { opacity: 1 } }}
                onClick={() => window.open("https://linkedin.com", "_blank")}
              >
                <LinkedInIcon />
              </IconButton>
              <IconButton
                sx={{ color: "white", opacity: 0.8, "&:hover": { opacity: 1 } }}
                onClick={() => window.open("https://facebook.com", "_blank")}
              >
                <FacebookIcon />
              </IconButton>
              <IconButton
                sx={{ color: "white", opacity: 0.8, "&:hover": { opacity: 1 } }}
                href="mailto:support@amyloidconnect.com"
              >
                <EmailIcon />
              </IconButton>
            </Box>
          </Grid>

          {/* Products */}
          <Grid item xs={12} md={2}>
            <Typography variant="h6" fontWeight={700} gutterBottom>
              Products
            </Typography>
            {[
              { label: "AmyloidConnect", path: "/products/amyloidconnect" },
              { label: "NephroTrax", path: "/products/nephrotrax" },
              { label: "Compass", path: "/products/compass" },
              { label: "ResourceClan", path: "/products/resourceclan" },
              { label: "Platforms", path: "/platforms" },
            ].map((item) => (
              <Link
                key={item.path}
                component={RouterLink}
                to={item.path}
                sx={{
                  display: "block",
                  color: "rgba(255,255,255,0.8)",
                  textDecoration: "none",
                  mb: 1,
                  "&:hover": { color: "#f9a825" },
                }}
              >
                {item.label}
              </Link>
            ))}
          </Grid>

          {/* Company */}
          <Grid item xs={12} md={2}>
            <Typography variant="h6" fontWeight={700} gutterBottom>
              Company
            </Typography>
            {[
              { label: "About Us", path: "/about" },
              { label: "Services", path: "/services" },
              { label: "Solutions", path: "/solutions" },
              { label: "Contact", path: "/contact" },
            ].map((item) => (
              <Link
                key={item.path}
                component={RouterLink}
                to={item.path}
                sx={{
                  display: "block",
                  color: "rgba(255,255,255,0.8)",
                  textDecoration: "none",
                  mb: 1,
                  "&:hover": { color: "#f9a825" },
                }}
              >
                {item.label}
              </Link>
            ))}
          </Grid>

          {/* Contact */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" fontWeight={700} gutterBottom>
              Contact Us
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.8, mb: 1 }}>
              📧 reviewer@verainsight.com
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.8, mb: 1 }}>
              🌐 www.verainsight.com
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.8, mb: 1 }}>
              📍 Minneapolis, MN
            </Typography>
            <Box
              sx={{
                mt: 2,
                p: 2,
                bgcolor: "rgba(255,255,255,0.1)",
                borderRadius: 2,
              }}
            >
              <Typography variant="body2" sx={{ opacity: 0.9 }}>
                🏥 <strong>AmyloidConnect:</strong> www.amyloidconnect.com
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.9, mt: 0.5 }}>
                💧 <strong>NephroTrax:</strong> www.nephrotrax.com
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.9, mt: 0.5 }}>
                🧭 <strong>Compass:</strong> verainsight.com/compass
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.9, mt: 0.5 }}>
                🤝 <strong>ResourceClan:</strong> In Progress
              </Typography>
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ my: 4, borderColor: "rgba(255,255,255,0.2)" }} />

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 2,
          }}
        >
          <Typography variant="body2" sx={{ opacity: 0.7 }}>
            © {new Date().getFullYear()} VeraInsight Healthcare Inc. All rights
            reserved.
          </Typography>
          <Box sx={{ display: "flex", gap: 3 }}>
            {["Privacy Policy", "Terms of Service", "HIPAA"].map((item) => (
              <Link
                key={item}
                href="#"
                sx={{
                  color: "rgba(255,255,255,0.7)",
                  textDecoration: "none",
                  fontSize: "0.85rem",
                  "&:hover": { color: "#f9a825" },
                }}
              >
                {item}
              </Link>
            ))}
          </Box>
        </Box>
      </Container>
    </Box>
  );
}